import { useEffect } from 'react';
import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

// TODO: This could be changed to match SGI's error format closely, however, it shouldn't be coupled to the API implementation
export type ServerError = {
  [key: string]: string[];
};

// This converts our server errors to a format that react-hook-form understands
export function addServerError<T>(
  error: { attribute: string; details: string[] },
  setError: (name: Path<T>, error: { message: string; type: string }) => void,
) {
  setError(error.attribute as Path<T>, {
    // Rule Name
    message: error.details.join('. '),
    type: 'server',
  });
}

export const useServerErrorToFormError = <T extends FieldValues>({
  serverError,
  setError,
}: {
  serverError?: ServerError | undefined | null;
  setError: UseFormSetError<T>;
}) => {
  useEffect(() => {
    if (serverError) {
      for (const key in serverError) {
        addServerError({ attribute: key, details: serverError[key] }, setError);
      }
    }
  }, [serverError, setError]);
};
